export default class UploadAdapter {
    constructor(loader) {
        this.loader = loader;
        this.xhr = null;
    }

    upload() {
        return this.loader.file.then(file => {
            return new Promise((resolve, reject) => {
                this._initRequest();
                this._initListeners(resolve, reject, file);
                this._sendRequest(file);
            });
        });
    }

    abort() {
        if (this.xhr) {
            this.xhr.abort();
        }
    }

    _initRequest() {
        const url = `/api/v1/editor/upload`;
        this.url = url;

        this.xhr = new XMLHttpRequest();
        this.xhr.open('POST', url, true);
        this.xhr.responseType = 'json';

        const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

        if (csrf) {
            this.xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        }
    }

    _initListeners(resolve, reject, file) {
        const genericErrorText = `Couldn't upload file: ${file.name}.`;

        this.xhr.addEventListener('error', () => reject(genericErrorText));
        this.xhr.addEventListener('abort', () => reject());
        this.xhr.addEventListener('load', () => {
            const response = this.xhr.response;

            if (!response || !response.url) {
                return reject(response?.message || genericErrorText);
            }

            resolve({
                default: response.url
            });
        });

        if (this.xhr.upload) {
            this.xhr.upload.addEventListener('progress', evt => {
                if (evt.lengthComputable) {
                    this.loader.uploadTotal = evt.total;
                    this.loader.uploaded = evt.loaded;
                }
            });
        }
    }

    _sendRequest(file) {
        const data = new FormData();
        data.append('file', file);
        this.xhr.send(data);
    }
}
